import { iconDocAnalise, iconDocDocumento, iconFinCartao, iconFinGrafico, iconMarcaLogoVida, iconVidaAssistPessoal } from '@bsds-lib-component/icons/icons';
import React, { useCallback, useEffect, useId, useMemo, useState } from 'react';

import { Tab, type TabItem } from '../../components';
import { useBreadcrumb } from '../../context/BreadcrumbContext';
import { useIsAdmin } from '../../store/companyStore';

import AdhesionProposalTab from './tabs/adhesionProposal/AdhesionProposalTab';
import ContractTab from './tabs/contract/ContractTab';
import DashboardPaymentTab from './tabs/dashboardPayment/DashboardPaymentTab';
import PaymentTab from './tabs/payment/PaymentTab';
import InclusionProponentesTab from './tabs/inclusionProponentes/InclusionProponentesTab';
import SelfBillingTab from './tabs/selfBilling/SelfBillingTab';

const VidaPage: React.FC = () => {
  const mainContentId = useId();
  const { setTabBreadcrumbSuffix, clearBreadcrumbSuffix } = useBreadcrumb();
  const [activeTabId, setActiveTabId] = useState('proposta-adesao');
  const isBackoffice = useIsAdmin();

  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: 'proposta-adesao',
        title: 'Proposta de Adesão',
        icon: iconDocDocumento,
        content: <AdhesionProposalTab />,
      },
      {
        id: 'inclusao-proponentes',
        title: 'Inclusão de Proponentes',
        icon: iconMarcaLogoVida,
        content: <InclusionProponentesTab />,
      },
      {
        id: 'pagamentos',
        title: 'Pagamentos',
        icon: iconFinCartao,
        content: <PaymentTab />,
        visible: !isBackoffice,
      },
      {
        id: 'consulta-apolices',
        title: 'Consulta de Apólices',
        icon: iconDocAnalise,
        content: <ContractTab />,
      },
      {
        id: 'auto-faturamento',
        title: 'Auto-Faturamento',
        icon: iconVidaAssistPessoal,
        content: <SelfBillingTab />,
      },
      {
        id: 'dashboard-faturamento',
        title: 'Dashboard de Faturamento',
        icon: iconFinGrafico,
        content: <DashboardPaymentTab />,
        visible: false,
      },
    ],
    []
  );

  const handleActiveTabChange = useCallback((tab: TabItem) => {
    setActiveTabId(tab.id);
  }, []);

  useEffect(() => {
    const activeTab = tabs.find((tab) => tab.id === activeTabId);
    if (!activeTab) {
      return;
    }

    setTabBreadcrumbSuffix([{ label: activeTab.title }]);
    return () => clearBreadcrumbSuffix();
  }, [activeTabId, tabs, setTabBreadcrumbSuffix, clearBreadcrumbSuffix]);

  return (
    <div
      className="bsds-width-100"
      role="main"
      aria-label="Página de Vida"
      id={mainContentId}
    >
      <div className="bsds-display-flex bsds-align-items-center">
        <div className="w-[2.5px] h-8  bg-red-600 bsds-mr-12" aria-hidden="true" />
        <h2 className="opacity-80">Vida</h2>
      </div>
      <Tab
        tabs={tabs}
        defaultTabId="proposta-adesao"
        className="bsds-mt-12"
        onActiveTabChange={handleActiveTabChange}
      />
    </div>
  );
};

export default VidaPage;
